import React from 'react';
import { SVGIcon } from '@superops/super-icons';

export const getBackgroundIcon = (iconPath, color, size) => {
  return iconPath ? (
    <SVGIcon name={iconPath} color={color} size={size} />
  ) : null;
};

export const fieldIconMap = {
  MULTI_SELECT: 'MultiSelectNew',
  SELECT: 'SelectNew',
  CHECKBOX: 'CheckBox',
  RADIO: 'RadioButton',
  DATETIME: 'DateTime',
  DATE: 'DatePicker',
  DECIMAL: 'Decimal',
  NUMERIC: 'Numeric',
  PARAGRAPH: 'LongText',
  TEXT: 'ShortText',
  PASSWORD: 'Lock',
  SECURE_TEXT: 'Lock',
  URL: 'LinkDark',
  PAYMENT: 'PAYMENT'
};

const RenderFieldTypeIcon = (props) => {
  const { type, color = '#000000', size = 'md', cateogry, columnName } = props;
  let icon = getBackgroundIcon(fieldIconMap[type?.toUpperCase()], color, size);
  if (cateogry === 'DEFAULT') {
    icon = getBackgroundIcon(
      type === 'PAYMENT' ? fieldIconMap.PAYMENT : fieldIconMap.SELECT,
      color,
      size
    );
  }
  return icon;
};

export default RenderFieldTypeIcon;
